"use strict";

import diasReportComponent from "./dias.report.component";

const diasReport = angular.module("dias.report", []);

diasReport.directive("diasReport", diasReportComponent);

export default diasReport;
